import { Link } from "react-router-dom";
import { ReactElement } from "react";

interface HomepageProps {
  username: string;
}

export default function Homepage({ username }: HomepageProps) {
  let authenticatedLinks: ReactElement = <></>;
  if (username) {
    authenticatedLinks = (
      <div>
        <p className="lead fw-bold">
          <Link className="text-decoration-none" to="/qa">
            Question & Answers
          </Link>
        </p>
        <p className="lead fw-bold">
          <Link className="text-decoration-none" to="/short-url">
            Short URL
          </Link>
        </p>
        <p className="lead fw-bold">
          <Link className="text-decoration-none" to="/activity">
            Activity
          </Link>
        </p>
      </div>
    );
  }

  return (
    <div className="rounded border m-1 pt-4 text-center bg-white">
      {authenticatedLinks}
      <p className="lead fw-bold">
        <Link className="text-decoration-none" to="/sudoku">
          Sudoku
        </Link>
      </p>
      <p className="lead fw-bold">
        <Link className="text-decoration-none" to="/match-color">
          Color Matcher
        </Link>
      </p>
      <p className="lead fw-bold">
        <Link className="text-decoration-none" to="/photo-editor">
          Photo Editor
        </Link>
      </p>
    </div>
  );
}
